// frontend/src/context/AuthContext.js

import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [userProfile, setUserProfile] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('accessToken'));
  const [isLoading, setIsLoading] = useState(true); 

  const fetchUserProfile = useCallback(async () => {
    if (!token) {
      setUserProfile(null);
      setIsLoading(false);
      return;
    }
    try {
      const response = await api.get('/meu-perfil/');
      setUserProfile(response.data);
    } catch (error) {
      console.error("Falha ao buscar perfil do usuário, realizando logout.", error);
      logout();
    } finally {
        setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    setIsLoading(true);
    fetchUserProfile();
  }, [fetchUserProfile]);

  const login = async (email, password) => {
    const response = await api.post('/token/', { username: email, password });
    const { access, refresh } = response.data;
    localStorage.setItem('accessToken', access);
    if (refresh) {
      localStorage.setItem('refreshToken', refresh);
    }
    setToken(access);
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    setToken(null);
    setUserProfile(null);
    window.location.href = '/login';
  };

  const contextValue = {
    user: userProfile, 
    token,
    login,
    logout,
    isLoading
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};